import styled, { css } from 'styled-components'

import { Button as ButtonBase } from '@icontainers/design-system/dist/molecules/Button'

export const SelectedLanguage = styled.div`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.black};
    margin-right: 5px;

    .Dark & {
        color: ${(props) => props.theme.color.white};
    }

    .Light & {
        color: ${(props) => props.theme.color.black};
    }

    .Transparent & {
        color: ${(props) => props.theme.color.white};
    }

    @media ${(props) => props.theme.query.tablet} {
        ${(props) => props.theme.typo.bodyS}
    }
`

export const Button = styled(ButtonBase)<{ sc: { isOpen: boolean | undefined } }>`
    button.root {
        background: transparent;
        padding-left: 4px;
        padding-right: 4px;
        min-width: auto;
        border-radius: 0px;
        min-height: 53px;
        margin-top: 5px;
        border-bottom: 5px solid transparent;

        &:hover {
            background: transparent;
            box-shadow: none;
            border-bottom-color: ${(props) => props.theme.color.a500};
        }

        ${(props) =>
            props.sc.isOpen &&
            css`
                border-bottom-color: ${(props) => props.theme.color.a500};
            `}

        @media only screen and (max-width: 991px) {
            min-height: auto;
            color: ${(props) => props.theme.color.g600};
            border: 0;

            &:hover {
                color: ${(props) => props.theme.color.g600};
            }

            svg {
                path {
                    fill: ${(props) => props.theme.color.g600};
                }
            }
        }

        @media ${(props) => props.theme.query.desktop} {
            min-height: 75px;
        }
    }
`
